




// eslint-disable-next-line no-unused-vars
import { DropdownItem } from '@/main/store/@types/dropdown.d';
import { BaseInput } from '@/main/components/dms/common/baseInput';


export default BaseInput.extend({
	name: 'DmsSubstring',
	props: {
		useKorektni: Boolean,
	},
	computed: {
		selectList(): DropdownItem[] {
			const list = [
				{ Text: this.Localize('Vinsubstr_rez0'), Label: null, Disabled: false, Value: 0 },
				{ Text: this.Localize('Vinsubstr_rez1'), Label: null, Disabled: false, Value: 1 },
				{ Text: this.Localize('Vinsubstr_rez2'), Label: null, Disabled: false, Value: 2 },
				{ Text: this.Localize('Vinsubstr_rez3'), Label: null, Disabled: false, Value: 3 },
			];
			if (this.useKorektni) { list.push({ Text: this.Localize('Vinsubstr_rez4'), Label: null, Disabled: false, Value: 4 }); }

			return list;
		},
	},
});
